import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';
import { THEME_ACCENT_COLORS } from './chanakyaColors';

const Pill = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  background: ${p => p.accent}18;
  color: ${p => p.accent};
  border: 1px solid ${p => p.accent};
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
`;

const ThemeTag = ({ theme, cell, lang = 'en' }) => {
  const t = useLocale(lang, 'chanakyaNiti');
  const accent = THEME_ACCENT_COLORS[theme] || '#455A64';
  const label = t.themes?.[theme] || theme;
  const ariaLabel = (t.themeAriaLabel || 'Theme: {theme}, Aphorism {n}')
    .replace('{theme}', label)
    .replace('{n}', cell);

  return (
    <Pill accent={accent} aria-label={ariaLabel}>
      {label}
    </Pill>
  );
};

export default ThemeTag;
